/**
 * Активный закреп для плашки по позиции относительно viewport ленты.
 * Берём самый новый, который ещё не целиком ниже нижней границы
 * (во viewport или выше). Если все уже ушли вниз — самый старый.
 *
 * @param pinEventIdsNewestFirst — eventId от новых к старым
 * @param isEntirelyBelow — true: сообщение целиком ниже viewport;
 *   false: пересекает или выше; null: нет данных (пропускаем)
 */
export const resolveActivePinnedEventId = (
  pinEventIdsNewestFirst: number[],
  isEntirelyBelow: (eventId: number) => boolean | null,
): number | undefined => {
  if (!pinEventIdsNewestFirst.length) {
    return undefined
  }

  for (const eventId of pinEventIdsNewestFirst) {
    const below = isEntirelyBelow(eventId)
    if (below === false) {
      return eventId
    }
  }

  return pinEventIdsNewestFirst[pinEventIdsNewestFirst.length - 1]
}

/** top >= bottom → целиком ниже нижней кромки viewport */
export const isRectEntirelyBelowViewport = (
  elementTop: number,
  viewportBottom: number,
  epsilon = 1,
): boolean => elementTop >= viewportBottom - epsilon
